/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable no-confusing-arrow */
import styled from 'styled-components';
import * as FiIcons from 'react-icons/fi';

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
`;

export const FormTitle = styled.p`
  font-family: BiotifMedium;
  color: #1c1b3a;
  font-size: 22px;
  margin: 0;
  text-align: center;
`;

export const CloseIcon = styled.img`
  height: auto;
  width: 14px;
  cursor: pointer;
`;

export const EyeIcon = styled(FiIcons.FiEye)`
  width: 16px;
  height: 16px;
  cursor: pointer;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ModalContent = styled.div`
  display: flex;
`;

export const FormRow = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 200px;
  max-height: 200px;
  overflow-y: scroll;
  width: 100%;

  &::-webkit-scrollbar {
    width: 8px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    background: #f3f4f8 0% 0% no-repeat padding-box;
    border-radius: 4px;
    opacity: 1;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: #222247 0% 0% no-repeat padding-box;
    border-radius: 4px;
    opacity: 1;
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

type DocumentRowProps = {
  stripped?: boolean;
};

export const DocumentRow = styled.div<DocumentRowProps>`
  display: flex;
  width: 98%;
  justify-content: space-between;
  padding: 10px;
  background: ${props => (props.stripped ? '#f3f4f8 0% 0% no-repeat padding-box' : '')};
`;

export const IconsSlot = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
`;
